import { render, staticRenderFns } from "./_studata.vue?vue&type=template&id=becb0c2e&"
import script from "./_studata.vue?vue&type=script&lang=js&"
export * from "./_studata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports